<script setup lang="ts">
  import { type WMModal } from '../composables/WM';
  import Icon from './Icon.vue';

  const props = defineProps<{
    modal: WMModal,
    containerCssClass: string,
    titleCssClass: string,
    closeCssClass: string,
  }>();
</script>

<template>
  <div :class="props.containerCssClass">
    <div :class="props.titleCssClass" v-if="props.modal.title">{{ props.modal.title }}</div>
    <Icon v-if="props.modal.isCloseable" icon="close" element="button" :css-class="props.closeCssClass" @click="modal.close(undefined)" />
    <component :is="props.modal.component" v-bind="{ ...modal.props, modal: modal}"></component>
  </div>
</template>

<style scoped>

</style>